export default __webpack_public_path__ + "static/0-430abd667a1650a6e0e030c17bea7483.png";